import { GraphQlClient } from '@intelipost-js/secure-providers';

export default {
  getTrackingStatusList({ commit }) {
    commit('setLoading', true);

    return GraphQlClient.query(
      `query{
        logisticProviderTracking{
          status
          logistic_provider{
            name
          }
          last_try
          last_update
          last_info
          files_processed
          details
        }
      }`)

    .then((res) => {
      commit('setLogisticProviderTracking', res.data.logisticProviderTracking || []);
      commit('setLoading', false);
      return Promise.resolve(res);
    })
      .catch(() => commit('setLoading', false));
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/features/tracking-status/store/actions.js